import { Center, Image, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import Lixo from '../../../images/Excluido.svg';
import { useLocation } from 'react-router-dom';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
const Sucesso = () => {
  return (
    <>
      <VStack w={'100%'}>
        <Image src={Lixo} height={'100%'} />
        <Text color={'#585858'} fontWeight={'bold'}>
          {' '}
          O cartão foi excluído com sucesso{' '}
        </Text>
      </VStack>
    </>
  );
};

const Erro = () => {
  return (
    <>
      <VStack>
        <Text> Não foi possível excluir o cartão no momento</Text>
      </VStack>
    </>
  );
};

function CartaoStatus() {
  const state = useLocation();
  const sucesso = state?.state;
  return (
    <>
      <ChildHeader />
      <Center mt={"5%"}>
        {sucesso ? (
          <>
            <Sucesso />
          </>
        ) : (
          <>
            <Erro />
          </>
        )}
      </Center>
    </>
  );
}

export default CartaoStatus;
